import React, { useState } from "react";
import { ReactNode } from "react";

export enum BannerType {
  INFO = "INFO",
  ACTION = "ACTION",
  ERROR = "ERROR",
}
export enum BannerButtonVariant {
  PRIMARY = "PRIMARY",
  OUTLINE = "OUTLINE",
}

export interface BannerButton {
  variant: BannerButtonVariant;
  title: string;
  onClick: () => void;
  icon?: ReactNode;
}

export interface ActionBannerInterface {
  title: string;
  description: string;
  onLearnButton?: BannerButton;
  onActionButton?: BannerButton;
}


export interface InformationBannerDataInterface {
  type: BannerType;
  data: ActionBannerInterface;
}

export interface InformationBannerContextInterface {
  isShown: boolean;
  bannerData: InformationBannerDataInterface | undefined;
  showBanner: (value: boolean) => void;
  setBannerData: (value: InformationBannerDataInterface) => void;
}

export interface InformationBarProps {
  children: ReactNode;
}

export const InformationBannerContext =
  React.createContext<InformationBannerContextInterface>({
    isShown: false,
    bannerData: undefined,
    showBanner: (_show: boolean) => {
      return;
    },
    setBannerData: (_value: InformationBannerDataInterface) => {
      return;
    },
  });

const InformationBannerProvider = ({
  children,
}: InformationBarProps): JSX.Element => {
  const { Provider } = InformationBannerContext;
  const [isShown, setShowBanner] = useState<boolean>(false);
  const [bannerData, setBannerData] =
    useState<InformationBannerDataInterface>();

  return (
    <Provider
      value={{ bannerData, setBannerData, isShown, showBanner: setShowBanner }}
    >
      {children}
    </Provider>
  );
};

export default InformationBannerProvider;
